// Geo enrichment is disabled: the previous implementation called the
// third-party GeoIP service api.ip.sb directly from the browser, leaking the
// user's IP (PII) to a non-contracted processor during the auth flow. Rebrand
// behind a first-party endpoint / the auth challenge before re-enabling.
export async function fetchPasskeyGeo(): Promise<string | undefined> {
  return undefined;
}

/** Browser + device (+ optional geo); used for Cognito deviceInfo and passkey registration labels. */
export function formatPasskeyDeviceLabel(geo?: string): string {
  const ua = navigator.userAgent;
  const browser = /Firefox/.test(ua)
    ? "Firefox"
    : /Edg/.test(ua)
      ? "Edge"
      : /Chrome/.test(ua)
        ? "Chrome"
        : /Safari/.test(ua)
          ? "Safari"
          : "Browser";
  let device = /Mac/.test(ua)
    ? "Mac"
    : /Windows/.test(ua)
      ? "Windows"
      : /iPhone|iPad/.test(ua)
        ? (ua.match(/iPhone|iPad/)?.[0] ?? "iOS")
        : /Android/.test(ua)
          ? "Android"
          : "Device";
  if (/Samsung|SM-/.test(ua)) {
    device = "Samsung";
  }
  let s = `${browser} on ${device}`;
  if (geo) {
    s += ` (${geo})`;
  }
  return s;
}
